import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  /** Reserved size while the section is offscreen; keeps scrollbar stable. */
  minHeight?: string;
  className?: string;
};

/**
 * Wraps below-the-fold sections with `content-visibility: auto`, which lets
 * the browser skip layout, paint, and (for offscreen subtrees) style work
 * until the section scrolls near the viewport. This is the cheapest win for
 * long homepages: the LCP paint is no longer blocked by cost of rendering
 * 15+ sections that aren't visible on first frame.
 *
 * `contain-intrinsic-size` reserves vertical space so scroll position and
 * anchor links stay stable while the browser defers work.
 */
export function DeferredSection({
  children,
  minHeight = "800px",
  className,
}: Props) {
  return (
    <div
      className={className}
      style={{
        contentVisibility: "auto",
        containIntrinsicSize: `1px ${minHeight}`,
      }}
    >
      {children}
    </div>
  );
}
